<app-buy-sell-menu>
    <app-data-grid-comp
        category="Buy-Sell-Approvals"
        [gridId]="gridId"
        [columns]="columns"
        [hideActionButtons]="true"
        [filterCategories]="filterCategories"
        [gridDataResult]="gridDataResult"
        [pageSize]="pageSize"
        [skip]="skip"
        [clearSelectedItems]="clearSelectedItems"
        [rowSelectionSettings]="{
            canSelectRows: false,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        searchable="true"
        showRefreshButton="true"
        (emitRefreshEvent)="getBuySellApprovals()"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitOpenDialogEvent)="openBuySellRequest($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
    ></app-data-grid-comp>
</app-buy-sell-menu>
